<template>
<div>
    <h1 class="display-heading">Dashboard</h1>

    <div class="row">
        <div class="col-sm-6">
             <div class="card mb-4">
                <div class="card-body">
                    <h5 class="mb-3">Total Video Consultations</h5>
                    <div class="d-flex mb-3">
                        <div class="mr-3 flex-grow-1">
                            <datetime-picker ref="totalVideoConsultation" class="form-control"></datetime-picker>
                        </div>
                        <div>
                            <button class="btn btn-primary btn-primary-insv" @click="viewTotalConsultations">View</button>
                        </div>
                    </div>
                    <div class="d-flex justify-content-center">
                        <div class="dashboard-count">
                            <span class="digit">{{paidConsultations.count}}</span>
                            <span class="ml-3">Video Consultation<span v-if="paidConsultations.count>1">s</span></span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-sm-6">
             <div class="card mb-4">
                <div class="card-body">
                    <h5 class="mb-3">Total Purchase of Medicines</h5>
                    <div class="d-flex mb-3">
                        <div class="mr-3 flex-grow-1">
                            <datetime-picker ref="totalPurchasedMedicine" class="form-control"></datetime-picker>
                        </div>
                        <div>
                            <button class="btn btn-primary btn-primary-insv" @click="viewTotalPurchasedMedicine">View</button>
                        </div>
                    </div>
                    <div class="d-flex justify-content-center">
                        <div class="dashboard-count">
                            <span class="digit">{{paidPrescriptions.count}}</span>
                            <span class="ml-3">Purchase<span v-if="paidPrescriptions.count>1">s</span></span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="row">
        <div class="col-sm-6">
             <div class="card mb-4">
                <div class="card-body">
                    <h5 class="mb-3">Total Expenses of Consultations</h5>
                    <div class="d-flex mb-3">
                        <div class="mr-3 flex-grow-1">
                            <datetime-picker ref="totalExpenseVideoConsultations" class="form-control"></datetime-picker>
                        </div>
                        <div>
                            <button class="btn btn-primary btn-primary-insv" @click="viewTotalExpenseConsultations">View</button>
                        </div>
                    </div>
                    <div class="d-flex justify-content-center">
                        <div class="dashboard-count">
                            <span class="digit">RM {{totalExpenseVideoConsultations.amount.toFixed(2)}}</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-sm-6">
             <div class="card mb-4">
                <div class="card-body">
                    <h5 class="mb-3">Total Expenses of Medicines</h5>
                    <div class="d-flex mb-3">
                        <div class="mr-3 flex-grow-1">
                            <datetime-picker ref="totalExpenseMedicines" class="form-control"></datetime-picker>
                        </div>
                        <div>
                            <button class="btn btn-primary btn-primary-insv" @click="viewTotalExpensePurchasedMedicine">View</button>
                        </div>
                    </div>
                    <div class="d-flex justify-content-center">
                        <div class="dashboard-count">
                            <span class="digit">RM {{totalExpenseMedicines.amount.toFixed(2)}}</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import moment from 'moment';
import datetimePicker from '@/components/datetime-picker';
export default {
    'name': 'UserDashboard',
    'components': {
        datetimePicker
    },
    data () {
        return {
            'paidConsultations': {
                'startDate': null,
                'endDate': null,
                'count': 0
            },
            'paidPrescriptions': {
                'startDate': null,
                'endDate': null,
                'count': 0
            },
            'totalExpenseVideoConsultations': {
                'startDate': null,
                'endDate': null,
                'amount': 0
            },
            'totalExpenseMedicines': {
                'startDate': null,
                'endDate': null,
                'amount': 0
            }
        };
    },
    mounted () {
        this.getDashboard();
    },
    'methods': {
        getDashboard () {
            this.axios.get('Dashboard/GetCompanyDashboard').then(({ data }) => {
                if (data.data.tc) {
                    this.setVideoConsultation(data.data.tc);
                }

                if (data.data.tp) {
                    this.setPurchasedMedicine(data.data.tp);
                }

                if (data.data.tec) {
                    this.setTotalExpenseConsultations(data.data.tec);
                }

                if (data.data.tem) {
                    this.setTotalExpensePurchasedMedicine(data.data.tem);
                }
            });
        },
        setVideoConsultation (consultationCount) {
            this.paidConsultations.count = consultationCount.c;
            this.paidConsultations.startDate = moment(consultationCount.sd);
            this.paidConsultations.endDate = moment(consultationCount.ed);

            this.$refs.totalVideoConsultation.setDate(this.paidConsultations.startDate, this.paidConsultations.endDate);
        },
        setPurchasedMedicine (paidMedicineCount) {
            this.paidPrescriptions.count = paidMedicineCount.c;
            this.paidPrescriptions.startDate = moment(paidMedicineCount.sd);
            this.paidPrescriptions.endDate = moment(paidMedicineCount.ed);

            this.$refs.totalPurchasedMedicine.setDate(this.paidPrescriptions.startDate, this.paidPrescriptions.endDate);
        },
        viewTotalConsultations () {
            let { startDate, endDate } = this.$refs.totalVideoConsultation.getDates();
            this.axios.post('Dashboard/GetCompanyDashboardTotalVideoConsultation',
                {
                    'sd': startDate.toISOString(true),
                    'ed': endDate.toISOString(true)

                }).then(({ data }) => {
                this.setVideoConsultation(data.data);
            });
        },
        viewTotalPurchasedMedicine () {
            let { startDate, endDate } = this.$refs.totalPurchasedMedicine.getDates();
            this.axios.post('Dashboard/GetCompanyDashboardTotalMedicinePayments',
                {
                    'sd': startDate.toISOString(true),
                    'ed': endDate.toISOString(true)

                }).then(({ data }) => {
                this.setPurchasedMedicine(data.data);
            });
        },
        viewTotalExpenseConsultations () {
            let { startDate, endDate } = this.$refs.totalExpenseVideoConsultations.getDates();
            this.axios.post('Dashboard/GetCompanyDashboardExpenseConsultations',
                {
                    'sd': startDate.toISOString(true),
                    'ed': endDate.toISOString(true)

                }).then(({ data }) => {
                this.setTotalExpenseConsultations(data.data);
            });
        },
        viewTotalExpensePurchasedMedicine () {
            let { startDate, endDate } = this.$refs.totalExpenseMedicines.getDates();
            this.axios.post('Dashboard/GetCompanyDashboardExpenseMedicines',
                {
                    'sd': startDate.toISOString(true),
                    'ed': endDate.toISOString(true)

                }).then(({ data }) => {
                this.setTotalExpensePurchasedMedicine(data.data);
            });
        },
        setTotalExpenseConsultations (totalExpense) {
            this.totalExpenseVideoConsultations.amount = totalExpense.a;
            this.totalExpenseVideoConsultations.startDate = moment(totalExpense.sd);
            this.totalExpenseVideoConsultations.endDate = moment(totalExpense.ed);

            this.$refs.totalExpenseVideoConsultations.setDate(this.totalExpenseVideoConsultations.startDate, this.totalExpenseVideoConsultations.endDate);
        },
        setTotalExpensePurchasedMedicine (totalExpense) {
            this.totalExpenseMedicines.amount = totalExpense.a;
            this.totalExpenseMedicines.startDate = moment(totalExpense.sd);
            this.totalExpenseMedicines.endDate = moment(totalExpense.ed);

            this.$refs.totalExpenseMedicines.setDate(this.totalExpenseMedicines.startDate, this.totalExpenseMedicines.endDate);
        }
    }
};
</script>

<style>

</style>
